var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"sf-footer"},[_vm._ssrNode("<div class=\"sf-footer__container\""+(_vm._ssrStyle(null,{ 'grid-template-columns': ' 1fr'.repeat(_vm.column) }, null))+">","</div>",[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }